// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"0":"1c1e35d9","4":"04208259","89":"b7fc0bfc","92":"569c1e60","266":"d7a9edc5","309":"17b491db","347":"46713d2d","440":"60a7fb50","460":"45ba15e9","536":"e479c1fe","662":"10eaabfa","700":"7e5eb13f","769":"b57531b6","884":"1efa91a0","955":"c71a9956"}[chunkId] + ".js";
};